// extracted by mini-css-extract-plugin
export default {"text":"ProductCard_text__-Zaxg","button":"ProductCard_button__o2-nd","mainPerk":"ProductCard_mainPerk__JBhdE"};